import { FC } from "react";
import { Ii18nInterpolationObject } from "src/@types/i18next";

export enum RegistrationFields {
  email = "email",
  firstName = "first_name",
  lastName = "last_name",
  phoneNumber = "phone_number",
  password = "password",
  role = "role",
  country = "country",
  companyName = "company_name",
  companyAddress = "company_address",
  website = "website",
  industry = "industry",
  description = "description",
  international = "international",
  foundingDocs = "founding_docs",
  reprecentionCountries = "reprecention_countries",
}

export interface StepControlsProps {
  isLoading: boolean;
  isFirstStep: boolean;
  isLastStep: boolean;
  onNextClick: VoidFunction;
  onPrevClick: VoidFunction;
}
export interface IStep {
  id: string;
  responsibleFields: RegistrationFields[];
  stepTitle: Ii18nInterpolationObject;
  stepComponent: FC<StepControlsProps>;
}
